export function FileIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M58.6668 26.6666V39.9999C58.6668 53.3333 53.3335 58.6666 40.0002 58.6666H24.0002C10.6668 58.6666 5.3335 53.3333 5.3335 39.9999V23.9999C5.3335 10.6666 10.6668 5.33325 24.0002 5.33325H37.3335"
        stroke="#E8E9EE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M58.6668 26.6666H48.0002C40.0002 26.6666 37.3335 23.9999 37.3335 15.9999V5.33325L58.6668 26.6666Z"
            stroke="#E8E9EE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}